export const config = {
    api: {
        baseUrl: process.env.VUE_APP_API_BASE_URL,
    },
    emails: {
        company: process.env.VUE_APP_COMPANY_EMAIL,
        vacancy: process.env.VUE_APP_VACANCY_EMAIL,
        support: process.env.VUE_APP_SUPPORT_EMAIL,
    },
};
